import { FC } from 'react';
import styled from 'styled-components';
import { useAppSelector } from '../../../../../common/store';

interface BotChatMessageTimestampProps {
  timestamp: string;
  actor: string; // 'U' | 'A' | 'live_agent' | others (ignored)
}

export const BotChatMessageTimestamp: FC<BotChatMessageTimestampProps> = ({
  timestamp,
  actor,
}) => {
    const merchIdHash = useAppSelector((state) => state["app-state"].merchIdHash);
  // Only render if actor is recognized
  if (!['U', 'A', 'live_agent'].includes(actor)) return null;

  return (
    <BotChatMessageTimestampContainer actor={actor} merchIdHash={merchIdHash}>
      {timestamp}
    </BotChatMessageTimestampContainer>
  );
};

const BotChatMessageTimestampContainer = styled.div<{ actor: string; merchIdHash?: string }>`
  display: flex;
  align-items: center;
  justify-content: ${({ actor }) => (actor === 'U' ? 'flex-end' : 'flex-start')};
  width: 100%;
  gap: 0.25rem;
  font-size: 0.75rem;
  color: #6B7280;
  margin-top: 0.25rem;
  padding-left: ${({ merchIdHash }) => (merchIdHash === 'b6783969bc077c42bef036b471e89631d7e6ca9d4f1a6032b5ad2c0e982a7dec' || merchIdHash === "791e9e38e1202463594144e4d463570797949c5fa07c6366596e0d2b9e709588" ? '3rem' : '4.5rem')};
  padding-right: 0.5rem;
`;

